$bog_music_nav $mol_view
	section? \music
	dev false
	sub /
		<= Tab_search $bog_music_nav_item
			label \Поиск
			active <= search_active \off
			Icon <= Search_icon $mol_icon_magnify
			click? <=> search_click? null
		<= Tab_music $bog_music_nav_item
			label \Музыка
			active <= music_active \off
			Icon <= Music_icon $mol_icon_playlist_music
			click? <=> music_click? null
		<= Tab_account $bog_music_nav_item
			label \Аккаунт
			active <= account_active \off
			Icon <= Account_icon $mol_icon_account_circle
			click? <=> account_click? null
		<= Tab_logs $bog_music_nav_item
			label \Логи
			active <= logs_active \off
			Icon <= Logs_icon $mol_icon_text_box_outline
			click? <=> logs_click? null
